import { inject, Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { IUser } from '../../users-management/interfaces';
import { AuthStore } from '../store/auth.store';

@Injectable({ providedIn: 'root' })
export class CurrentUserResolver implements Resolve<IUser | null> {
  readonly authStore = inject(AuthStore);

  resolve(): IUser | null {
    return this.authStore.currentUser();
  }
}
